// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__lhUl8","spin":"Spinner_spin__mV5YI"};